import React from 'react';
import { Box, SkeletonGroup, SkeletonRectangle } from '@wix/design-system';
import { INSIGHT_ROW_GAP } from '../HeroInsightBullets';
import s from './HeroCard.css';
const ROW_HEIGHT = 'var(--wds-font-line-height-body-medium)';
export const HeroBulletsSkeleton = () => /*#__PURE__*/React.createElement(SkeletonGroup, {
  skin: "light",
  className: s.skeletonGroup
}, /*#__PURE__*/React.createElement(Box, {
  direction: "vertical",
  gap: INSIGHT_ROW_GAP,
  width: "100%"
}, /*#__PURE__*/React.createElement(SkeletonRectangle, {
  className: s.skeleton,
  width: "260px",
  height: ROW_HEIGHT
}), /*#__PURE__*/React.createElement(SkeletonRectangle, {
  className: s.skeleton,
  width: "340px",
  height: ROW_HEIGHT
})));
//# sourceMappingURL=HeroBulletsSkeleton.js.map